import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function SiteFooter() {
  const { t } = useLanguage();

  const links = [
    { href: "/#fenomeno", label: t.nav.fenomeno },
    { href: "/#coste", label: t.nav.coste },
    { href: "/#solucion", label: t.nav.solucion },
    { href: "/#privacidad", label: t.nav.privacidad },
    { href: "/#contacto", label: t.nav.cta },
  ];

  return (
    <footer className="bg-forest-950 py-14" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <div>
            <p className="font-body text-sm font-bold tracking-[0.2em] text-cream">
              WASTEDATA <span className="mx-1 text-cream/40">|</span> <span className="text-cream/60">INFINICITY</span>
            </p>
            <p className="mt-2 font-body text-[10px] uppercase tracking-[0.3em] text-mint/70">
              {t.footer.tagline}
            </p>
          </div>
          <nav className="flex flex-wrap gap-6" data-testid="footer-nav">
            {links.map((link) => (
              <a key={link.href} href={link.href} className="text-[13px] text-cream/60 transition-colors hover:text-cream">
                {link.label}
              </a>
            ))}
            <Link to="/documentos" data-testid="footer-link-documentos" className="text-[13px] text-cream/60 transition-colors hover:text-cream">
              {t.nav.documentos}
            </Link>
          </nav>
        </div>

        <div className="rule-light mt-10 pt-6 text-xs text-cream/45">
          <p data-testid="footer-legal">
            © {new Date().getFullYear()} {t.footer.legal}
          </p>
          <div className="mt-3 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <p className="font-mono">
              <a href="mailto:info@infinicity.es" data-testid="footer-email" className="transition-colors hover:text-mint">
                info@infinicity.es
              </a>
              <span className="mx-2 text-cream/25">·</span>
              <a href="tel:+34624544020" data-testid="footer-phone" className="transition-colors hover:text-mint">
                +34 624 544 020
              </a>
              <span className="mx-2 text-cream/25">·</span>wastedata.eu
            </p>
            <p data-testid="footer-patent">{t.footer.patent}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
